// @flow

import React from 'react';
import type { Props } from '.';
import './syswarn.scss';

export default class SystemWarnBanner extends React.Component<Props> {
  props: Props;

  renderMessageContent() {
    const { syswarnmessage, closeSysWarn, samClosed } = this.props;
    return !samClosed && (
      <div
        className="syswarn-message"
      >
        <button className="syswarn-close" onClick={closeSysWarn} type="button">
          <button type="button" className="close" aria-label="Close">
            <svg width="20px" height="20px" className="inner-icon" viewBox="0 0 21 21" version="1.1">
              <title>Cross</title>
              <path d="M0,1 L19,20 L20,18 L2,0 L0,2 Z" fill="#fff" />
              <path d="M19,0 L0,19 L2,20 L20,2 L18,0 Z" fill="#fff" />
            </svg>
          </button>
        </button>
        <p>{syswarnmessage.message}</p>
      </div>
    );
  }

  render() {
    const { syswarnmessage } = this.props;
    if (syswarnmessage && syswarnmessage.msgId) {
      return this.renderMessageContent();
    }
    return null;
  }
}
